import { render, staticRenderFns } from "./vue-slot-wheel.vue?vue&type=template&id=dbfd0c08&"
import script from "./vue-slot-wheel.vue?vue&type=script&lang=js&"
export * from "./vue-slot-wheel.vue?vue&type=script&lang=js&"
import style0 from "./vue-slot-wheel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports